export default __webpack_public_path__ + "static/media/icn-message-info.99b7c02b.svg";